import type { QueryClient } from '@tanstack/vue-query';
import { billingKeys } from './billing.keys';

export async function invalidateBillingQueries(queryClient: QueryClient, tenantId: number): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: billingKeys.status(tenantId) }),
    queryClient.invalidateQueries({ queryKey: billingKeys.details(tenantId) }),
  ]);
}
